import { render, staticRenderFns } from "./BindsStepHeader.vue?vue&type=template&id=efa1252c&"
import script from "./BindsStepHeader.vue?vue&type=script&lang=js&"
export * from "./BindsStepHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports